import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../../PanelPage";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService";
import {Messages} from "../../../../../Messages";
import {BackButton} from "../../../../../../core/ui/LinkButton.jsx";
import {Flow} from "../../../../flows/Flow.js";
import {MessageElement} from "../../../../../widget/ui/MessageElement";
import {BlinkButton} from "../../../../../../core/ui/Button.jsx";


export class CancelDonationPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.donatePageCancelDonationTitle,
        };
    }

    render() {
        const {styleSheet} = this;
        const merchantName = iFrameMerchantService.getMerchant().name;

        return [
            <MessageElement message={Messages.donatePageCancelDonationText1(merchantName)} />,
            <MessageElement message={Messages.donatePageCancelDonationText2(merchantName)} />,
            <BlinkButton
                label={Messages.donatePageCancelDonationButton}
                onClick={() => Flow.donation.cancelActiveDonation()}
                className={styleSheet.actionButton}
            />,
            <BackButton />,
        ];
    }
}
